export default __webpack_public_path__ + "static/media/63t.e56688e3.jpg";